'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _markdownIt = require('markdown-it');

var _markdownIt2 = _interopRequireDefault(_markdownIt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var pairedTypes = {
    "bullet_list": function bullet_list(content, style, className, token) {
        return _react2.default.createElement(
            'ul',
            { key: token.id, style: style, className: className },
            content
        );
    },
    "ordered_list": function ordered_list(content, style, className, token) {
        var startAttr = token.attrs && token.attrs.find(function (x) {
            return x[0] === 'start';
        });
        return _react2.default.createElement(
            'ol',
            { key: token.id,
                style: style,
                className: className,
                start: startAttr && startAttr.length > 1 ? startAttr[1] : 1 },
            content
        );
    },
    "list_item": function list_item(content, style, className, token) {
        return _react2.default.createElement(
            'li',
            { key: token.id, style: style, className: className },
            content
        );
    },
    "paragraph": function paragraph(content, style, className, token) {
        return _react2.default.createElement(
            'p',
            { key: token.id, style: style, className: className },
            content
        );
    },
    "link": function link(content, style, className, token) {
        var hrefAttr = token.attrs && token.attrs.find(function (x) {
            return x[0] === 'href';
        });
        return _react2.default.createElement(
            'a',
            { key: token.id,
                style: style,
                href: hrefAttr && hrefAttr.length > 1 ? hrefAttr[1] : '',
                target: '_blank',
                className: className },
            content
        );
    },
    "s": function s(content, style, className, token) {
        return _react2.default.createElement(
            's',
            { key: token.id, style: style, className: className },
            content
        );
    },
    "strong": function strong(content, style, className, token) {
        return _react2.default.createElement(
            'strong',
            { key: token.id, style: style, className: className },
            content
        );
    },
    "em": function em(content, style, className, token) {
        return _react2.default.createElement(
            'em',
            { key: token.id, style: style, className: className },
            content
        );
    }

};
var inlineType = 'inline';
var unpairedTypes = {
    "code_inline": function code_inline(content, style, className, token) {
        return _react2.default.createElement(
            'span',
            { key: token.id, style: style, className: className },
            content
        );
    },
    "hardbreak": function hardbreak(_, style, className, token) {
        return _react2.default.createElement('br', { key: token.id, style: style, className: className });
    },
    "softbreak": function softbreak(_, style, className, token) {
        return _react2.default.createElement('br', { key: token.id, style: style, className: className });
    },
    "text": function text(content, style, className, token) {
        return _react2.default.createElement(
            'span',
            { key: token.id, style: style, className: className },
            content
        );
    },
    "emoji": function emoji(content, style, className, token) {
        return _react2.default.createElement(
            'span',
            { key: token.id, style: style, className: className },
            content
        );
    }
};

var renderMarkdownEnvTokens = function renderMarkdownEnvTokens(parsedContent, styles, classNames) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var closingPairTokenKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

    var currentIndex = index;
    var renderingList = [];

    var _loop = function _loop() {
        var currentToken = parsedContent[currentIndex];
        var pairedTypeKey = Object.keys(pairedTypes).find(function (pairedType) {
            return pairedType + '_open' === currentToken.type;
        });
        if (pairedTypeKey) {
            var _renderMarkdownEnvTok = renderMarkdownEnvTokens(parsedContent, styles, classNames, currentIndex + 1, pairedTypeKey + '_close'),
                content = _renderMarkdownEnvTok.content,
                closingPairIndex = _renderMarkdownEnvTok.lastIndex;

            renderingList.push(pairedTypes[pairedTypeKey](content, styles[pairedTypeKey], classNames[pairedTypeKey], currentToken));
            currentIndex = closingPairIndex;
        } else if (currentToken.type === inlineType) {
            renderingList.push(_react2.default.createElement(
                'span',
                { key: currentToken.id },
                renderMarkdownEnvTokens(currentToken.children, styles, classNames).content
            ));
        } else if (Object.keys(unpairedTypes).includes(currentToken.type)) {
            renderingList.push(unpairedTypes[currentToken.type](currentToken.content, styles[currentToken.type], classNames[pairedTypeKey], currentToken));
        } else {
            console.warn('Markdown token: ' + currentToken.type + ', is not supported', currentToken);
        }
        currentIndex++;
    };

    while (currentIndex < parsedContent.length && parsedContent[currentIndex].type !== closingPairTokenKey) {
        _loop();
    }

    return { content: renderingList, lastIndex: currentIndex };
};

var baseStyles = {
    "bullet_list": { marginTop: "0", marginBottom: "0", paddingInlineStart: "25px" },
    "ordered_list": { marginTop: "0", marginBottom: "0", paddingInlineStart: "25px" },
    "paragraph": { margin: "0" }
};

var ReactMarkdownRenderer = function (_Component) {
    _inherits(ReactMarkdownRenderer, _Component);

    function ReactMarkdownRenderer(props) {
        _classCallCheck(this, ReactMarkdownRenderer);

        var _this = _possibleConstructorReturn(this, (ReactMarkdownRenderer.__proto__ || Object.getPrototypeOf(ReactMarkdownRenderer)).call(this, props));

        var _this$props = _this.props,
            _this$props$markdowni = _this$props.markdownit,
            markdownit = _this$props$markdowni === undefined ? new _markdownIt2.default() : _this$props$markdowni,
            children = _this$props.children;

        _this.state = {
            parsedContent: markdownit.parse(children, {})
        };
        return _this;
    }

    _createClass(ReactMarkdownRenderer, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                children = _props.children,
                _props$markdownit = _props.markdownit,
                markdownit = _props$markdownit === undefined ? new _markdownIt2.default() : _props$markdownit;

            if (children !== prevProps.children) {
                this.setState({ parsedContent: markdownit.parse(children, {}) });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                styles = _props2.styles,
                classNames = _props2.classNames;

            return _react2.default.createElement(
                'span',
                null,
                renderMarkdownEnvTokens(this.state.parsedContent, _extends({}, baseStyles, styles), classNames).content
            );
        }
    }]);

    return ReactMarkdownRenderer;
}(_react.Component);

ReactMarkdownRenderer.propTypes = {
    markdownit: _propTypes2.default.object,
    styles: _propTypes2.default.object
};

exports.default = ReactMarkdownRenderer;